import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProvideAuth } from "./hooks/use-auth";
import reset from 'styled-reset'
import { createGlobalStyle } from 'styled-components';
import config from "./config";


const GlobalStyle = createGlobalStyle`
  ${reset}
  *, *::after, *::before {
    box-sizing: border-box;
  }
  body {
    background-color: ${config.style.backgroundColor.body};
  }
`
ReactDOM.render(
  <>
    <GlobalStyle />
    <ProvideAuth>
      <App />
    </ProvideAuth>
  </>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
